<template>
  <div class="container about">
    <!-- <h1>这是介绍页面</h1> -->

    <div class="row">
      <div class="col-6">
        <div class="panel yellow">
          <div class="panel-wrapper">
            <div class="panel-main-content">
              <div class="panel-heading"></div>
              <div class="panel-body">
                <div class="badge yellow">随时<br>考评</div>
                <h2>考评者<br><small>为中心</small></h2>

                <div class="summary">
                  同一时刻<span>1</span>考评者<span>1</span>考评对象，不同考评者可使用不同评分表
                </div>
              </div>
            </div>

            <div class="panel-info-content">
              <ul class="nav intro-01">
                <li>考评者下载所需评分表</li>
                <li>考评者批量添加被考评对象</li>
                <li>考评者扫码获取被考评对象</li>
                <li>考评中查看当日考评记录</li>
                <li>考评后查看所有考评记录</li>
                <li>导出考评者考评记录</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="panel orange">
          <div class="panel-wrapper">
            <div class="panel-main-content">
              <div class="panel-heading"></div>
              <div class="panel-body">
                <div class="badge orange">计划<br>考试</div>
                <h2>一场考试<br><small>为中心</small></h2>

                <div class="summary">
                  多样化的排考策略可满足不同需求的技能考核
                </div>
              </div>
            </div>

            <div class="panel-info-content">
              <ul class="nav intro-02">
                <li>多种排考策略：轮循/队列/单站/多站/长短站/多考道</li>
                <li>多终端引导考生有序进站</li>
                <li>考站对应多道考题用于抽题考核，考站有限、考核无限</li>
                <li>面对面手持评分/远程电脑评分（最大程度双盲）</li>
                <li>全局监视控制所有监控点，多路视频同时录制</li>
                <li>多维度数据分析，分析失分率</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="panel blue">
          <div class="panel-wrapper">
            <div class="panel-main-content">
              <div class="panel-heading"></div>
              <div class="panel-body">
                <div class="badge blue">技能<br>大赛</div>
                <h2>一场大赛<br><small>为中心</small></h2>

                <div class="summary">
                  选手分别作战/接力赛，按团队总成绩进行排名
                </div>
              </div>
            </div>

            <div class="panel-info-content">
              <ul class="nav intro-03">
                <li>初赛为多站轮循式排考，复赛为赛道式排考</li>
                <li>多终端引导选手有序进站</li>
                <li>以评分表为单位计算成绩</li>
                <li>系统记录团队成绩和每位选手的成绩</li>
                <li>全局监视控制所有监控点，多路视频同时录制</li>
                <li>多维度数据分析，分析失分率</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="panel green">
          <div class="panel-wrapper">
            <div class="panel-main-content">
              <div class="panel-heading"></div>
              <div class="panel-body">
                <div class="badge green">随时<br>练</div>
                <h2>学生<br><small>为中心</small></h2>

                <div class="summary">
                  随时随地扫描二维码，学习专业技能知识
                </div>
              </div>
            </div>

            <div class="panel-info-content">
              <ul class="nav intro-04">
                <li>学生扫描二维码，自主学习专业技能知识</li>
                <li>学生实际操练录制视频作业，学练相结合</li>
                <li>作业被老师评价和标记，清楚自己的操作情况</li>
                <li>作业被老师标记为经典案例，供其他同学回顾学习</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "introduce",
  mounted: function() {
    // 用 vue 的事件，很崩溃，mouseleave 只能在别的 mouseenter 时触发
    // @click="onClick" @mouseenter="onMouseenter" @mouseleave="onMouseleave"
    $('.panel').hover(function() {
      $(this).find('.panel-wrapper').css({'top': '-300px'});
    }, function() {
      $(this).find('.panel-wrapper').css({'top': '0'});
    });
  },
  methods: {
    // onClick: function() {
    //   console.log('onClick');
    // },
    // onBlur: function() {
    //   console.log('onBlur');
    // },
    onMouseenter: function() {
      // // panel-wrapper
      // event.target.childNodes[0].style.top = '-300px';
      // event.currentTarget.style.top = '-300px';
      // console.log(event.target.childNodes[0]);
      // console.log(event.currentTarget.childNodes[0]);
      console.log('onMouseenter');
      // console.log(event.currentTarget);
      // console.log(event.currentTarget.childNodes[0]);

      let target = event.currentTarget.childNodes[0];
      $(target).css({'top': '-300px'});
    },
    onMouseleave: function() {
      // // panel-wrapper
      // event.target.childNodes[0].style.top = '0';
      // event.currentTarget.style.top = '0';
      // console.log(event.target.childNodes[0]);
      // console.log(event.currentTarget.childNodes[0]);
      console.log('onMouseleave');
      // console.log(event.currentTarget.childNodes[0]);

      let target = event.currentTarget.childNodes[0];
      $(target).css({'top': '0'});
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .panel {
  position: relative;
  height: 300px;
  overflow: hidden;
  padding: 0;

  &-wrapper {
    position: absolute;
    top: 0;
    width: 100%;
    transition: top 0.3s ease;
    // transform: translateY(0%);
    // transition: all .5s;
  }

  &-main-content,
  &-info-content {
    height: 300px;
    padding: 20px;
  }

  &-info-content {
    // background-color: #2277e6;
    background: linear-gradient(to right, #2277e6, rgba(34, 119, 230, 0.9));
    color: #fff;
    // background: linear-gradient(to right, #2277e6, rgba(34, 119, 230, 0.9));

    .nav li {
      margin-bottom: 20px;
      height: 24px;
      border-left: 3px solid #fff;
      padding-left: 15px;
      font-size: 16px;
      line-height: 24px;
    }

    .nav {
      height: 100%;
      background-position: bottom right;
      background-repeat: no-repeat;
    }

    .intro-01 { background-image: url("../assets/intro-bg01.png"); }
    .intro-02 { background-image: url("../assets/intro-bg02.png"); }
    .intro-03 { background-image: url("../assets/intro-bg03.png"); }
    .intro-04 { background-image: url("../assets/intro-bg04.png"); }
  }

  &-heading { border-bottom: 3px solid #ccc; }
  h2 {
    font-size: 24px;
    text-align: center;
    small { color: #666; font-size: 18px; font-weight: 300; }
  }

  &.yellow {
    h2 { color: #fbc127; }
    .panel-heading { border-color: #fbc127; }
  }
  &.orange {
    h2 { color: #ee7f1a; }
    .panel-heading { border-color: #ee7f1a; }
  }
  &.red {
    h2 { color: #f00; }
    .panel-heading { border-color: #f00; }
  }
  &.blue {
    h2 { color: #2478e6; }
    .panel-heading { border-color: #2478e6; }
  }
  &.green {
    h2 { color: #7ebf4f; }
    .panel-heading { border-color: #7ebf4f; }
  }

  .badge {
    margin: 30px auto;
    width: 70px;
    height: 70px;
    padding: 10px 0;
    color: #fff;
    font-size: 18px;
  }

  .summary {
    margin-top: 30px;
    color: #666;
    font-weight: 300;
    text-align: center;
    line-height: 35px;

    span { margin: 0 5px; font-size: 28px; font-weight: 700; vertical-align: bottom; }
  }
}

@media screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (orientation : landscape) {
  /deep/ .panel .summary {
      font-size: 14px;
      span { font-size: 20px; }
  }
}
</style>
